/* CAFFREY Walk On Air — page behaviour. v2 (Claude Code, 2026-10-07, Alex's second-pass notes; v1: launch build 2026-10-06).
   <cf-woa-gallery>   four photos in one frame: arrows + dots SLIDE the photos (animated, v3); swipe on touch, arrow keys;
                      snaps, never pans.
   <cf-woa-buy>       size radios (EU + the box's US/CA) -> the form's hidden [name=id] (+ bubbling change, KIT.md §4a), price,
                      Add to cart state, ?variant= URL, quantity stepper, size-table highlight, the size-chart sheet.
                      Nothing preselected: Add to cart, Shop Pay and the kit sticky bar ask for a size first.
   <cf-woa-mechanism> "Where your weight lands.": every point and every label opens its own card; one pulse on first view.
   <cf-woa-ribbon>    the carton's curved lines as twisted ribbons of hairlines (sky -> deep teal, fading ends), drawn in once.
   Lazy: the anatomy image loads ~400 px before it scrolls in; photos 2-4 load after the page has loaded.
   Safe to load more than once (defer). No dependencies. prefers-reduced-motion: no pulse, no drawing, no smooth scroll. */
(function () {
  if (window.CfWoaPage) return;
  window.CfWoaPage = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* Alex 2026-10-07: the Klaviyo pop-up is hidden on this page (cf-woa-page.css); Klaviyo still adds its scroll lock to
     <body> while it thinks the pop-up is open, so release it whenever it appears. */
  (function () {
    var b = document.body;
    if (!b) return;
    var free = function () { if (b.classList.contains('klaviyo-prevent-body-scrolling')) b.classList.remove('klaviyo-prevent-body-scrolling'); };
    free();
    if ('MutationObserver' in window) new MutationObserver(free).observe(b, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ---------------- gallery: arrows + dots over a snapping strip ---------------- */
  class WoaGallery extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.track = this.querySelector('[data-woa-slides]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-woa-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-woa-dot]'));
      if (!this.track || this.slides.length < 2) return;
      this.index = 0;
      this.setAttribute('data-enhanced', '');
      var prev = this.querySelector('[data-woa-prev]');
      var next = this.querySelector('[data-woa-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); }); });
      this.track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        self.go(self.index + (e.key === 'ArrowRight' ? 1 : -1));
      });
      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking || self._raf) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = self.track.clientWidth || 1;
          self.mark(Math.round(self.track.scrollLeft / w));
        });
      }, { passive: true });
      /* photos 2-4: fetched once the page has loaded (or at the first touch of the gallery), so a tap never shows a gap */
      var warm = function () {
        self.slides.forEach(function (s) {
          var img = s.querySelector('img[data-woa-src]');
          if (!img) return;
          var set = img.getAttribute('data-woa-srcset');
          if (set) img.setAttribute('srcset', set); /* srcset before src: one download, the right width */
          img.setAttribute('src', img.getAttribute('data-woa-src'));
          img.removeAttribute('data-woa-src');
          img.removeAttribute('data-woa-srcset');
        });
      };
      if (document.readyState === 'complete') setTimeout(warm, 300); else window.addEventListener('load', function () { setTimeout(warm, 300); }, { once: true });
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { self.addEventListener(ev, warm, { once: true, passive: true }); });
    }
    /* Alex v3: the photo must visibly slide in. Browsers may jump a snapping strip on scrollTo(smooth), so the slide is
       animated here (ease-out, ~0.55 s) with snapping paused until it lands. Reduced motion: instant. */
    go(i) {
      var n = this.slides.length;
      i = ((i % n) + n) % n;
      this.mark(i);
      var self = this, track = this.track;
      var from = track.scrollLeft, to = i * track.clientWidth;
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
      if (reduced() || Math.abs(to - from) < 2) { track.scrollLeft = to; return; }
      var dur = Math.min(900, 480 + 120 * Math.abs(to - from) / (track.clientWidth || 1));
      var t0 = null;
      track.style.scrollSnapType = 'none';
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var t = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - t, 3);
        track.scrollLeft = from + (to - from) * e;
        if (t < 1) { self._raf = requestAnimationFrame(step); return; }
        self._raf = null;
        track.scrollLeft = to;
        track.style.scrollSnapType = '';
      };
      this._raf = requestAnimationFrame(step);
    }
    mark(i) {
      if (i === this.index && this._marked) return;
      this._marked = true;
      this.index = Math.max(0, Math.min(this.slides.length - 1, i));
      var k = this.index;
      this.dots.forEach(function (d, j) { d.setAttribute('aria-current', String(j === k)); });
    }
  }

  /* ---------------- buy box: size radios -> kit-compatible product form ----------------
     No size is preselected (fixer pass 2026-10-06): only the shopper or a ?variant= link chooses one. Until then:
     - the main "Add to cart" stays active and submitting asks for a size (message under the sizes, scroll, focus);
     - Shop Pay: Shopify greys its button while the form has no id, and a disabled button fires no click, so a
       transparent guard button covers it and asks for a size instead (hidden as soon as a size is chosen);
     - the kit sticky bar would print the first size or "Unavailable": it is patched to read "Choose your size" with an
       active "Add to cart" that presses the main button (which asks for a size).
     Once a size is chosen, the sticky bar shows it the way the sizes do ("EU 41–42", en dash). */
  class WoaBuy extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.idInput = this.form.querySelector('input[type="hidden"][name="id"]');
      if (this.idInput) this.idInput.disabled = false; /* disabled in the HTML so no-JS shoppers use the <noscript> select */
      this.atc = this.form.querySelector('[data-cf-atc]');
      this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
      this.qty = this.form.querySelector('input[name="quantity"]');
      this.msg = this.querySelector('[data-woa-size-msg]');
      this.sizes = this.querySelector('[data-woa-sizes]');
      this.guard = this.querySelector('[data-woa-pay-guard]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('input[data-woa-size]'));
      this.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('input[data-woa-size]')) self.select(e.target, true);
      });
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-woa-qty]');
        if (!b || !self.qty) return;
        var min = parseInt(self.qty.min, 10) || 1;
        self.qty.value = Math.max(min, (parseInt(self.qty.value, 10) || min) + Number(b.getAttribute('data-woa-qty')));
        self.qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
      /* Capture phase on an ancestor of the form: runs before Dawn's <product-form> submit handler on the form. */
      this.addEventListener('submit', function (e) {
        if (e.target !== self.form || self.current()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.ask();
      }, true);
      if (this.guard) this.guard.addEventListener('click', function (e) { e.preventDefault(); self.ask(); });
      /* Keyboard users can still reach Shopify's "More payment options" link under the guard: with no size chosen, a
         click anywhere in the payment block (Enter on the link included) asks for a size instead. */
      var pay = this.querySelector('[data-woa-pay]');
      if (pay) pay.addEventListener('click', function (e) {
        if (self.current() || (e.target.closest && e.target.closest('[data-woa-pay-guard]'))) return;
        e.preventDefault();
        e.stopPropagation();
        self.ask();
      }, true);
      this.chart();
      window.addEventListener('pageshow', function () { self.sync(); });
      this.sync();
      this.watchSticky();
    }
    /* "Size chart" opens the box chart right here (a sheet), cloned from the Description's Size chart row; without
       <dialog> support (or without that section) the link simply jumps to the row (opened, below). */
    chart() {
      var self = this;
      var open = this.querySelector('[data-woa-chart-open]');
      var dlg = document.querySelector('[data-woa-chart-dialog]');
      if (!open || !dlg || typeof dlg.showModal !== 'function') return;
      open.addEventListener('click', function (e) {
        if (!self.fillChart(dlg)) return;
        e.preventDefault();
        self._chartTrigger = open;
        dlg.showModal();
        var r = self.current();
        self.highlight(r ? r.getAttribute('data-title') : null);
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || (e.target.closest && e.target.closest('[data-woa-chart-close]'))) dlg.close();
      });
      dlg.addEventListener('close', function () { if (self._chartTrigger) self._chartTrigger.focus(); });
    }
    fillChart(dlg) {
      var slot = dlg.querySelector('[data-woa-chart-slot]');
      if (!slot) return false;
      if (slot.childElementCount) return true;
      var src = document.querySelector('[data-woa-chart-src]');
      if (!src) return false;
      var c = src.cloneNode(true);
      c.removeAttribute('data-woa-chart-src');
      each(c.querySelectorAll('img'), function (img) { img.loading = 'eager'; });
      slot.appendChild(c);
      return true;
    }
    current() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked) return this.radios[i];
      return null;
    }
    firstAvailable() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].getAttribute('data-available') === 'true') return this.radios[i];
      return null;
    }
    sync() {
      var r = this.current();
      if (r) this.select(r, false); else this.none();
    }
    setId(value) {
      if (this.idInput && this.idInput.value !== value) {
        this.idInput.value = value;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    highlight(title) {
      each(document.querySelectorAll('[data-woa-row]'), function (tr) {
        tr.classList.toggle('is-current', title !== null && tr.getAttribute('data-woa-row') === title);
      });
    }
    none() {
      var any = !!this.firstAvailable();
      this.setId('');
      this.highlight(null);
      if (this.atc) {
        this.atc.disabled = !any;
        if (this.atcLabel) this.atcLabel.textContent = any ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = !any;
      this.patchSticky();
    }
    select(r, byUser) {
      var available = r.getAttribute('data-available') === 'true';
      this.setId(r.value);
      var price = r.getAttribute('data-price');
      if (price) each(document.querySelectorAll('[data-woa-price]'), function (el) { el.textContent = price; });
      this.highlight(r.getAttribute('data-title'));
      if (this.atc) {
        this.atc.disabled = !available;
        if (this.atcLabel) this.atcLabel.textContent = available ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = true;
      this.clearAsk();
      this.patchSticky();
      if (byUser && !designMode() && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    }
    /* "Choose your size first.": message under the sizes, sizes highlighted, scrolled into view, first size focused. */
    ask() {
      var first = this.firstAvailable();
      var st = document.querySelector('cf-kit-sticky');
      if (st && typeof st.done === 'function') st.done();
      if (!first) return;
      if (this.msg) {
        this.msg.textContent = this.dataset.sizeError || '';
        this.msg.hidden = false;
      }
      if (this.sizes) {
        this.sizes.classList.remove('is-asking');
        void this.sizes.offsetWidth; /* restart the highlight when asked again */
        this.sizes.classList.add('is-asking');
        var box = this.sizes.getBoundingClientRect();
        if (box.top < 72 || box.bottom > window.innerHeight - 96) {
          this.sizes.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        }
      }
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    clearAsk() {
      if (this.msg && !this.msg.hidden) { this.msg.hidden = true; this.msg.textContent = ''; }
      if (this.sizes) this.sizes.classList.remove('is-asking');
    }
    /* The kit sticky bar (cf-kit-sticky, shared) mirrors the form's id: with none it reads "Unavailable". */
    watchSticky() {
      var self = this;
      var tries = 0;
      var attach = function () {
        var st = document.querySelector('cf-kit-sticky');
        if (!st) { if (++tries < 40) setTimeout(attach, 250); return; }
        if (self._stObs) return;
        self._st = st;
        self._stObs = new MutationObserver(function () { self.patchSticky(); });
        self._stObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        self.patchSticky();
      };
      attach();
    }
    patchSticky() {
      var st = this._st;
      if (!st) return;
      var btn = st.querySelector('[data-cf-sticky-atc]');
      var label = btn ? btn.querySelector('span') : null;
      var v = st.querySelector('[data-cf-sticky-variant]');
      var r = this.current();
      if (r) {
        var want = (this.dataset.prefix || '') + (r.getAttribute('data-label') || r.getAttribute('data-title') || '');
        if (v && v.textContent !== want) v.textContent = want;
        return; /* availability: the kit's own sync */
      }
      if (!this.firstAvailable()) return; /* nothing in stock: keep the kit's sold-out state */
      if (btn && btn.disabled) btn.disabled = false;
      if (label && label.textContent !== this.dataset.add) label.textContent = this.dataset.add;
      if (v && v.textContent !== this.dataset.choose) v.textContent = this.dataset.choose;
    }
  }

  /* ---------------- "Where your weight lands." ---------------- */
  class WoaMechanism extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.targets = Array.prototype.slice.call(this.querySelectorAll('[data-woa-zone]'));
      this.labels = Array.prototype.slice.call(this.querySelectorAll('.cf-woa-zone[data-woa-zone]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-woa-panel]'));
      this.lens = this.querySelector('[data-woa-lens]');
      this.lazyImages();
      if (!this.labels.length || !this.panels.length) return;
      this.setAttribute('data-enhanced', '');
      var group = this.querySelector('[data-woa-zones]');
      if (group) group.hidden = false;
      var hint = this.querySelector('[data-woa-hint]');
      if (hint) hint.hidden = false;

      this.targets.forEach(function (t) {
        t.addEventListener('click', function () { self.show(t.getAttribute('data-woa-zone')); });
      });
      this.labels.forEach(function (z, i) {
        z.addEventListener('keydown', function (e) {
          if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) < 0) return;
          e.preventDefault();
          var n = self.labels.length;
          var j = e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : (i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1) + n) % n;
          self.show(self.labels[j].getAttribute('data-woa-zone'));
          self.labels[j].focus();
        });
      });
      this.addEventListener('shopify:block:select', function (e) {
        var p = e.target.closest && e.target.closest('[data-woa-zone]');
        if (p) self.show(p.getAttribute('data-woa-zone'));
      });

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            self.loadLens();
            if (!self._pulsed && en.intersectionRatio >= 0.35 && !reduced()) {
              self._pulsed = true;
              self.setAttribute('data-pulse', '');
            }
          });
        }, { rootMargin: '240px 0px 240px 0px', threshold: [0, 0.35] });
        this.io.observe(this);
      } else {
        this.loadLens();
      }
      this.show(this.getAttribute('data-zone') || 'heel');
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.lio) this.lio.disconnect();
      this._init = false;
    }
    lazyImages() {
      var self = this;
      var imgs = Array.prototype.slice.call(this.querySelectorAll('img[data-woa-src]'));
      if (!imgs.length) return;
      var load = function () {
        imgs.forEach(function (img) {
          var set = img.getAttribute('data-woa-srcset');
          if (set) img.setAttribute('srcset', set); /* srcset before src: one download, the right width */
          img.setAttribute('src', img.getAttribute('data-woa-src'));
          img.removeAttribute('data-woa-src');
          img.removeAttribute('data-woa-srcset');
        });
        imgs = [];
        if (self.lio) { self.lio.disconnect(); self.lio = null; }
      };
      if (!('IntersectionObserver' in window)) { load(); return; }
      this.lio = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) load();
      }, { rootMargin: '400px 0px 400px 0px' });
      this.lio.observe(this.querySelector('.cf-woa-anatomy') || this);
    }
    loadLens() {
      if (this._lens || !this.lens) return;
      this._lens = true;
      var url = this.lens.getAttribute('data-woa-lens');
      var low = this.lens.getAttribute('data-woa-lens-1x');
      if (low && (window.devicePixelRatio || 1) < 1.5) url = low;
      if (url) this.lens.style.backgroundImage = 'url("' + url + '")';
    }
    show(zone) {
      if (!zone) return;
      this.setAttribute('data-zone', zone);
      this.labels.forEach(function (z) { z.setAttribute('aria-pressed', String(z.getAttribute('data-woa-zone') === zone)); });
      this.panels.forEach(function (p) { p.hidden = p.getAttribute('data-woa-panel') !== zone; });
    }
  }

  /* ---------------- the carton's curved lines: twisted ribbons of hairlines ----------------
     One S-sweep (upper right -> lower left, like the waves on the box front) in a 1000 x 1000 space. Each ribbon is n fine
     lines around that curve; the ribbon's signed half-width follows cos(), so the lines cross at a node and read as a
     ribbon turning in the air. A second, finer ribbon echoes the first (the box's two waves). Colour: the box's sky
     #A7D4E6 -> deep teal #436E7B, fading in and out at both ends. Strokes stay ~1 px at any size (--cf-woa-sw). */
  var RIBBONS = {
    hero: {
      segs: [[1250, -60, 980, 120, 860, 360, 660, 560], [660, 560, 460, 760, 240, 900, -250, 980]],
      grad: [1150, -40, -200, 980],
      sets: [{ n: 12, w: 70, tw: 1.6, ph: 0.05, shift: 210, cls: 'b' }, { n: 30, w: 190, tw: 1.2, ph: 0.5, shift: 0, cls: 'a' }]
    },
    stage: {
      segs: [[1200, 80, 960, 240, 820, 420, 620, 600], [620, 600, 420, 780, 200, 900, -220, 1040]],
      grad: [1120, 60, -160, 1040],
      sets: [{ n: 24, w: 170, tw: 1.1, ph: 0.35, shift: 0, cls: 'a' }]
    }
  };
  function bez(s, t) {
    var u = 1 - t;
    return [u * u * u * s[0] + 3 * u * u * t * s[2] + 3 * u * t * t * s[4] + t * t * t * s[6],
            u * u * u * s[1] + 3 * u * u * t * s[3] + 3 * u * t * t * s[5] + t * t * t * s[7]];
  }
  function onCurve(segs, t) {
    var n = segs.length, i = Math.min(Math.floor(t * n), n - 1);
    return bez(segs[i], t * n - i);
  }
  function normal(segs, t) {
    var a = onCurve(segs, Math.max(0, t - 0.001)), b = onCurve(segs, Math.min(1, t + 0.001));
    var dx = b[0] - a[0], dy = b[1] - a[1], L = Math.sqrt(dx * dx + dy * dy) || 1;
    return [-dy / L, dx / L];
  }
  function smooth(p) { /* Catmull-Rom through the samples -> cubic Béziers */
    var f = function (v) { return Math.round(v * 10) / 10; };
    var d = 'M' + f(p[0][0]) + ' ' + f(p[0][1]);
    for (var i = 0; i < p.length - 1; i++) {
      var p0 = p[Math.max(0, i - 1)], p1 = p[i], p2 = p[i + 1], p3 = p[Math.min(p.length - 1, i + 2)];
      d += 'C' + f(p1[0] + (p2[0] - p0[0]) / 6) + ' ' + f(p1[1] + (p2[1] - p0[1]) / 6) + ' ' +
        f(p2[0] - (p3[0] - p1[0]) / 6) + ' ' + f(p2[1] - (p3[1] - p1[1]) / 6) + ' ' + f(p2[0]) + ' ' + f(p2[1]);
    }
    return d;
  }
  function ribbonPaths(segs, o) {
    var out = [], samples = 16;
    for (var i = 0; i < o.n; i++) {
      var s = -1 + 2 * i / (o.n - 1), pts = [];
      for (var k = 0; k <= samples; k++) {
        var t = k / samples;
        var w = o.w * (0.16 + 0.84 * Math.cos(Math.PI * o.tw * t + o.ph * Math.PI));
        var c = onCurve(segs, t), nn = normal(segs, t), off = w * s + o.shift;
        pts.push([c[0] + nn[0] * off, c[1] + nn[1] * off]);
      }
      out.push(smooth(pts));
    }
    return out;
  }
  var ribbonId = 0;
  class WoaRibbon extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var cfg = RIBBONS[this.getAttribute('data-set')] || RIBBONS.hero;
      var id = 'cfwr' + (++ribbonId), g = cfg.grad;
      var svg = '<svg viewBox="0 0 1000 1000" preserveAspectRatio="xMidYMid slice" focusable="false"><defs>' +
        '<linearGradient id="' + id + 'a" gradientUnits="userSpaceOnUse" x1="' + g[0] + '" y1="' + g[1] + '" x2="' + g[2] + '" y2="' + g[3] + '">' +
        '<stop offset=".06" stop-color="#a7d4e6" stop-opacity="0"/><stop offset=".27" stop-color="#9fd0e4"/><stop offset=".55" stop-color="#5fa8c6"/>' +
        '<stop offset=".8" stop-color="#436e7b" stop-opacity=".9"/><stop offset="1" stop-color="#436e7b" stop-opacity="0"/></linearGradient>' +
        '<linearGradient id="' + id + 'b" gradientUnits="userSpaceOnUse" x1="' + g[0] + '" y1="' + g[1] + '" x2="' + g[2] + '" y2="' + g[3] + '">' +
        '<stop offset=".1" stop-color="#a7d4e6" stop-opacity="0"/><stop offset=".36" stop-color="#a7d4e6" stop-opacity=".9"/>' +
        '<stop offset=".75" stop-color="#83c2dd" stop-opacity=".7"/><stop offset="1" stop-color="#83c2dd" stop-opacity="0"/></linearGradient></defs>';
      var k = 0;
      cfg.sets.forEach(function (o) {
        svg += '<g class="cf-woa-ribbon__' + o.cls + '" stroke="url(#' + id + o.cls + ')">';
        ribbonPaths(cfg.segs, o).forEach(function (d) {
          svg += '<path d="' + d + '" pathLength="1" style="--i:' + (k++) + '"/>';
        });
        svg += '</g>';
      });
      this.innerHTML = svg + '</svg>';
      var self = this;
      /* hairlines: ~1.1 CSS px whatever the drawing's size (slice -> 1000 units span the larger side) */
      var fit = function () {
        var w = self.clientWidth, h = self.clientHeight;
        if (w && h) self.style.setProperty('--cf-woa-sw', (1.1 * 1000 / Math.max(w, h)).toFixed(2));
      };
      fit();
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(this);
      if (reduced() || !('IntersectionObserver' in window)) { this.setAttribute('data-drawn', ''); return; }
      this.setAttribute('data-draw', '');
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (en) { return en.isIntersecting; })) return;
        io.disconnect();
        requestAnimationFrame(function () { requestAnimationFrame(function () { self.setAttribute('data-drawn', ''); }); });
      }, { threshold: 0.15 });
      io.observe(this);
    }
  }

  /* The sub-nav "Size" link (and any #cf-woa-size link) opens the Description's Size chart row. */
  (function () {
    var openRow = function () { var d = document.querySelector('[data-woa-size-row]'); if (d && !d.open) d.open = true; };
    if (window.location.hash === '#cf-woa-size') openRow();
    window.addEventListener('hashchange', function () { if (window.location.hash === '#cf-woa-size') openRow(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#cf-woa-size"]');
      if (a && !a.hasAttribute('data-woa-chart-open')) openRow();
    });
  })();

  [['cf-woa-gallery', WoaGallery], ['cf-woa-buy', WoaBuy], ['cf-woa-mechanism', WoaMechanism], ['cf-woa-ribbon', WoaRibbon]].forEach(function (d) {
    if (!customElements.get(d[0])) customElements.define(d[0], d[1]);
  });
})();
